import { AvatarSize } from "../../Avatar";
import { FeedItemBaseSize } from "./FeedItemBase";

export function mapFeedItemSizeToAvatarSize(size: FeedItemBaseSize | undefined): AvatarSize | undefined {
  switch (size) {
    case "sm":
      return "sm";
    case "md":
      return "lg";
  }
}